export enum CatalogueSearchFilterType {
	types = "type",
	categories = "categories",
	owners = "owners",
	accessRights = "accessRights",
	terms = "terms",
	sortBy = "sortBy",
	sortDirection = "sortDirection",
	status = "status",
	sourceType = "sourceType",
	sessionName = "sessionName",
	organizationName = "organizationName",
	consolidationType = "consolidationType",
	taskTypeId = "taskTypeId",
	technologyId = "technologyId",
	taskTech = "taskTech",
}

export enum SortType {
	Name = "TITLE",
	Owner = "OWNER",
	Date = "RECORDISSUED",
	shortDescription = "SHORTDESCRIPTION",
	longDescription = "LONGDESCRIPTION",
	language = "LANGUAGE",
	publisher = "PUBLISHER",
	accessRights = "ACCESSRIGHTS",
	terms = "TERMS",
	categories = "CATEGORIES",
}

export const ACCESS_RIGHT_MAP: any = {
	PUBLIC: 1,
	PRIVATE: 2,
	RESTRICTED: 3,
};

export const ACCESS_RIGHT_REVERSE_MAP: any = {
	1: "PUBLIC",
	2: "PRIVATE",
	3: "RESTRICTED",
};

export enum SortDirection {
	ASC = "ASC",
	DESC = "DESC",
}
